function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "m32 0 32 18.1002584v36.2087855l-32 18.1002584-32-18.1002584v-36.2087855z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m58.2863049 53.0604651-25.227907 14.2718346v-11.1131783l15.7188631-8.6490956zm1.7281654-1.5627907v-29.8418604l-9.227907 5.3333333v19.1834625zm-54.40000002 1.5627907 25.22790702 14.2718346v-11.1131783l-15.7271318-8.6490956zm-1.72816537-1.5627907v-29.8418604l9.22790699 5.3333333v19.1834625zm1.08320413-31.7767442 25.87286826-14.63565888v10.74108528l-16.5788114 9.1204134-.1322998.0744186zm53.96175706 0-25.8728682-14.63565888v10.74108528l16.5788114 9.1121447.1322997.0744186z",
  fill: "#8ed6fb"
}), /*#__PURE__*/React.createElement("path", {
  d: "m30.8423773 53.6888889-15.5121447-8.5333333v-16.8930233l15.5121447 8.9550388zm2.2160206 0 15.5121447-8.5250646v-16.901292l-15.5121447 8.9550388zm-16.6780361-27.3777778 15.5700258-8.5581395 15.5700258 8.5581395-15.5700258 8.9881137z",
  fill: "#1c78c0"
}));

function SvgIconWebpack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 73,
    viewBox: "0 0 64 73",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWebpack);
export default __webpack_public_path__ + "static/media/icon-webpack.7a0c42a9.svg";
export { ForwardRef as ReactComponent };